var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1025 1024",
    style: {
      enableBackground: "new 0 0 1025 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4,320h576c35.4,0,64-28.7,64-64V128c0-35.3-28.6-64-64-64h-576c-35.4,0-64,28.7-64,64v128 C32.4,291.3,61,320,96.4,320z M544.4,128h128v128h-128V128z M288.4,128h192v128h-192V128z M96.4,128h128v128h-128V128z M672.4,512 h-576c-35.4,0-64,28.7-64,64v320c0,35.4,28.6,64,64,64h576c35.4,0,64-28.6,64-64V576C736.4,540.7,707.8,512,672.4,512z M224.4,896 h-128V768h128V896z M224.4,704h-128V576h128V704z M480.4,896h-192V768h192V896z M480.4,704h-192V576h192V704z M672.4,896h-128V768 h128V896z M672.4,704h-128V576h128V704z M924.3,263.4L756.1,375.9c-27.8,18.6-27.8,61.8,0,80.4l168.2,112.5 c29.7,19.8,68.3-2.8,68.3-40.2v-225C992.6,266.2,953.9,243.5,924.3,263.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableRow);
export default __webpack_public_path__ + "static/media/table-row.420c4b3a09005a61d43b12738aaa7462.svg";
export { ForwardRef as ReactComponent };